module.exports = __webpack_public_path__ + "static/media/payrollnew.1ed7c609.svg";